import React from "react"
import {Property} from "csstype"

interface CheckboxProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    label?: string,
    className?: string,
    fontSize?: Property.FontSize<string | number>
}

export default function WaCheckbox(props: CheckboxProps) {
    const {label, className, fontSize, ...otherProps} = props
    return (
        <label className={className} style={{fontSize: fontSize}}>
            <span className="wa-checkbox custom-mr-4">
                <input type={"checkbox"} {...otherProps} />
                <span>
                    <span className="icon">
                        <i className="fas fa-check"/>
                    </span>
                </span>
            </span>
            {label}
        </label>

    )
};